// extracted by mini-css-extract-plugin
export default {"events-container":"styles_events-container__suLz8","events-tile":"styles_events-tile__VCe2c"};